import { ExecutionResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import { DocumentNode } from 'graphql';
import { find } from 'lodash';

import { GetSharesItemsDocument, SharesItem, QueryGetSharesItemsArgs } from 'api';

interface IReducer {
  cache: DataProxy;
  result: ExecutionResult['data'];
  query: DocumentNode;
  variables: QueryGetSharesItemsArgs;
}

export default (options: IReducer) => {
  const { cache, result, query, variables } = options;
  const { getSharesItems } = cache.readQuery({
    query,
    variables,
  });

  if (!getSharesItems) {
    return;
  }

  const { updateScheduledShares } = result.data;
  getSharesItems.items_by_session = getSharesItems.items_by_session.map(
    (sharesItems: SharesItem[]) => {
      return sharesItems.map(sharesItem => {
        const update = find(updateScheduledShares, { id: sharesItem.id });
        if (update) {
          return {
            ...sharesItem,
            user_commentary: update.user_commentary,
            share_at: update.share_at,
          };
        }
        return sharesItem;
      });
    },
  );

  cache.writeQuery({
    query: GetSharesItemsDocument,
    variables,
    data: {
      getSharesItems,
    },
  });
};
